module.exports = __webpack_public_path__ + "img/bussiness-item-6.ac606369.png";